export default "__VITE_ASSET__JadqwLnn__"